import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
    const eventsBlockSlider = e.target.querySelector('.js-events-slider')

    if (eventsBlockSlider) {
        const splideInstance = new Splide('.js-events-slider', {
            arrows: false,
            pagination: false,
            perMove : 1,
            perPage: 3,
            gap: '30px',
            breakpoints: {
                991: {
                    perPage: 2,
                },
                719: {
                    perPage: 1,
                    gap: '15px',
                    padding: { right: '10%' },
                }
            }
        })

        splideInstance.mount()
    }
})
